// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyEditWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyEditWebApiHandler_additionalEmail,
  RentalManagerUserPropertyEditWebApiHandler_agentLicenseType,
  RentalManagerUserPropertyEditWebApiHandler_clearPropertyOnly,
  RentalManagerUserPropertyEditWebApiHandler_contactHours,
  RentalManagerUserPropertyEditWebApiHandler_contactName,
  RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee,
  RentalManagerUserPropertyEditWebApiHandler_email,
  RentalManagerUserPropertyEditWebApiHandler_forRentBy,
  RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving,
  RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking,
  RentalManagerUserPropertyEditWebApiHandler_hasBarbecue,
  RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage,
  RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless,
  RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasCableTv,
  RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan,
  RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning,
  RentalManagerUserPropertyEditWebApiHandler_hasCityView,
  RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasConcreteFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity,
  RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking,
  RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking,
  RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess,
  RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity,
  RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff,
  RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource,
  RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasElevator,
  RentalManagerUserPropertyEditWebApiHandler_hasFireplace,
  RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths,
  RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource,
  RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity,
  RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView,
  RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite,
  RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource,
  RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet,
  RentalManagerUserPropertyEditWebApiHandler_hasHotTub,
  RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity,
  RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths,
  RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths,
  RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths,
  RentalManagerUserPropertyEditWebApiHandler_hasMountainView,
  RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking,
  RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity,
  RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths,
  RentalManagerUserPropertyEditWebApiHandler_hasNoneParking,
  RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource,
  RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths,
  RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal,
  RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment,
  RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement,
  RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasPackageService,
  RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking,
  RentalManagerUserPropertyEditWebApiHandler_hasParkView,
  RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony,
  RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasPetPark,
  RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource,
  RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv,
  RentalManagerUserPropertyEditWebApiHandler_hasSauna,
  RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths,
  RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource,
  RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff,
  RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace,
  RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool,
  RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView,
  RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom,
  RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance,
  RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking,
  RentalManagerUserPropertyEditWebApiHandler_hasValetTrash,
  RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering,
  RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt,
  RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning,
  RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance,
  RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea,
  RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded,
  RentalManagerUserPropertyEditWebApiHandler_hasWaterView,
  RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning,
  RentalManagerUserPropertyEditWebApiHandler_hasWoodedView,
  RentalManagerUserPropertyEditWebApiHandler_hidePhone,
  RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress,
  RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted,
  RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive,
  RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience,
  RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Path,
  RentalManagerUserPropertyEditWebApiHandler_isFurnished,
  RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted,
  RentalManagerUserPropertyEditWebApiHandler_isListingEditable,
  RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Path,
  RentalManagerUserPropertyEditWebApiHandler_isOver55,
  RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired,
  RentalManagerUserPropertyEditWebApiHandler_laundry,
  RentalManagerUserPropertyEditWebApiHandler_leaseDuration,
  RentalManagerUserPropertyEditWebApiHandler_leaseTerms,
  RentalManagerUserPropertyEditWebApiHandler_modularListingProgress,
  RentalManagerUserPropertyEditWebApiHandler_name,
  RentalManagerUserPropertyEditWebApiHandler_parkingDescription,
  RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription,
  RentalManagerUserPropertyEditWebApiHandler_pets,
  RentalManagerUserPropertyEditWebApiHandler_phone,
  RentalManagerUserPropertyEditWebApiHandler_propertyType,
  RentalManagerUserPropertyEditWebApiHandler_securityDeposit,
  RentalManagerUserPropertyEditWebApiHandler_setAsPropertyOnly,
  RentalManagerUserPropertyEditWebApiHandler_smokingAllowed,
  RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding,
  RentalManagerUserPropertyEditWebApiHandler_videoUrl,
  RentalManagerUserPropertyEditWebApiHandler_webSite,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AgentLicenseType,
  DayOfWeek,
  ForRentByType,
  LeaseDuration,
  ListingAlias,
  PropertyType,
  RentalManagerLaundryType,
  RentalManagerModularListingProgressWebDto,
  UserPropertyEditContactHoursResponseWebDto,
  UserPropertyEditEmailResponseWebDto,
  UserPropertyEditPetsWebApiRequestDto,
  UserPropertyEditPhoneResponseWebDto,
  UserPropertyEditSecurityDepositResponseWebDto,
  UserPropertyIsConnectedExperienceResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface AdditionalEmailParams {
  additionalEmail?: string;
  listingAlias: ListingAlias;
}
interface AgentLicenseTypeParams {
  agentLicenseType?: AgentLicenseType;
  listingAlias: ListingAlias;
}
interface ClearPropertyOnlyParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId?: string;
}
interface ContactHoursParams {
  contactHours?: string;
  dayOfWeek: DayOfWeek;
  listingAlias: ListingAlias;
}
interface ContactNameParams {
  contactName?: string;
  listingAlias: ListingAlias;
}
interface DisplayTotalMonthlyPriceWithFeeParams {
  displayTotalMonthlyPriceWithFee?: boolean;
  listingAlias: ListingAlias;
}
interface EmailParams {
  email?: string;
  listingAlias: ListingAlias;
}
interface ForRentByParams {
  forRentBy?: ForRentByType;
  listingAlias: ListingAlias;
}
interface HasAirConditioningUtilityIncludedParams {
  hasAirConditioningUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasAssistedLivingParams {
  hasAssistedLiving?: boolean;
  listingAlias: ListingAlias;
}
interface HasAttachedGarageParkingParams {
  hasAttachedGarageParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasBarbecueParams {
  hasBarbecue?: boolean;
  listingAlias: ListingAlias;
}
interface HasBasketballSportCourtParams {
  hasBasketballSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasBicycleStorageParams {
  hasBicycleStorage?: boolean;
  listingAlias: ListingAlias;
}
interface HasBocceSportCourtParams {
  hasBocceSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasBuildingWideWirelessParams {
  hasBuildingWideWireless?: boolean;
  listingAlias: ListingAlias;
}
interface HasBusinessCenterCommunityRoomParams {
  hasBusinessCenterCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasCableTvParams {
  hasCableTv?: boolean;
  listingAlias: ListingAlias;
}
interface HasCableTvUtilityIncludedParams {
  hasCableTvUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasCarpetFloorCoveringParams {
  hasCarpetFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasCeilingFanParams {
  hasCeilingFan?: boolean;
  listingAlias: ListingAlias;
}
interface HasCentralAirConditioningParams {
  hasCentralAirConditioning?: boolean;
  listingAlias: ListingAlias;
}
interface HasCityViewParams {
  hasCityView?: boolean;
  listingAlias: ListingAlias;
}
interface HasClubHouseCommunityRoomParams {
  hasClubHouseCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasConcreteFloorCoveringParams {
  hasConcreteFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasConferenceRoomCommunityRoomParams {
  hasConferenceRoomCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasControlledAccessSecurityParams {
  hasControlledAccessSecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasConvectionOvenApplianceParams {
  hasConvectionOvenAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasCoveredParkingParkingParams {
  hasCoveredParkingParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasDeckOutDoorCommonAreaParams {
  hasDeckOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasDetachedGarageParkingParams {
  hasDetachedGarageParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasDisabledAccessParams {
  hasDisabledAccess?: boolean;
  listingAlias: ListingAlias;
}
interface HasDishwasherApplianceParams {
  hasDishwasherAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasDoormanSecurityParams {
  hasDoormanSecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasDoubleOvenApplianceParams {
  hasDoubleOvenAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasDryCleaningDropOffParams {
  hasDryCleaningDropOff?: boolean;
  listingAlias: ListingAlias;
}
interface HasElectricHeatingSourceParams {
  hasElectricHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasElectricityUtilityIncludedParams {
  hasElectricityUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasElevatorParams {
  hasElevator?: boolean;
  listingAlias: ListingAlias;
}
interface HasFireplaceParams {
  hasFireplace?: boolean;
  listingAlias: ListingAlias;
}
interface HasFitnessCenterCommunityRoomParams {
  hasFitnessCenterCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasFlexibleLeaseLengthsParams {
  hasFlexibleLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasFreezerApplianceParams {
  hasFreezerAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasGameRoomCommunityRoomParams {
  hasGameRoomCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasGarbageDisposalApplianceParams {
  hasGarbageDisposalAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasGarbageUtilityIncludedParams {
  hasGarbageUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasGardenOutDoorCommonAreaParams {
  hasGardenOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasGasHeatingSourceParams {
  hasGasHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasGasUtilityIncludedParams {
  hasGasUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasGatedEntrySecurityParams {
  hasGatedEntrySecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasGazeboOutDoorCommonAreaParams {
  hasGazeboOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasGolfCourseViewParams {
  hasGolfCourseView?: boolean;
  listingAlias: ListingAlias;
}
interface HasGuestSuiteParams {
  hasGuestSuite?: boolean;
  listingAlias: ListingAlias;
}
interface HasHardwoodFloorCoveringParams {
  hasHardwoodFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasHeatingUtilityIncludedParams {
  hasHeatingUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasHeatPumpHeatingSourceParams {
  hasHeatPumpHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasHighSpeedInternetParams {
  hasHighSpeedInternet?: boolean;
  listingAlias: ListingAlias;
}
interface HasHotTubParams {
  hasHotTub?: boolean;
  listingAlias: ListingAlias;
}
interface HasHotWaterUtilityIncludedParams {
  hasHotWaterUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasIntercomSecurityParams {
  hasIntercomSecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasInternetUtilityIncludedParams {
  hasInternetUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasLaminateFloorCoveringParams {
  hasLaminateFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasLawnOutDoorCommonAreaParams {
  hasLawnOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasLessThanOneYearLeaseLengthsParams {
  hasLessThanOneYearLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasLibraryCommunityRoomParams {
  hasLibraryCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasLinoleumFloorCoveringParams {
  hasLinoleumFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasLoungeCommunityRoomParams {
  hasLoungeCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasMicrowaveOvenApplianceParams {
  hasMicrowaveOvenAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasMonthlyLeaseLengthsParams {
  hasMonthlyLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasMoreThanOneYearLeaseLengthsParams {
  hasMoreThanOneYearLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasMountainViewParams {
  hasMountainView?: boolean;
  listingAlias: ListingAlias;
}
interface HasMultiLevelGarageParkingParams {
  hasMultiLevelGarageParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasMultiPurposeSportCourtParams {
  hasMultiPurposeSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasNightPatrolSecurityParams {
  hasNightPatrolSecurity?: boolean;
  listingAlias: ListingAlias;
}
interface HasNoneLeaseLengthsParams {
  hasNoneLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasNoneParkingParams {
  hasNoneParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasOilHeatingSourceParams {
  hasOilHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasOneYearLeaseLengthsParams {
  hasOneYearLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasOnlineMaintenancePortalParams {
  hasOnlineMaintenancePortal?: boolean;
  listingAlias: ListingAlias;
}
interface HasOnlineRentPaymentParams {
  hasOnlineRentPayment?: boolean;
  listingAlias: ListingAlias;
}
interface HasOnsiteManagementParams {
  hasOnsiteManagement?: boolean;
  listingAlias: ListingAlias;
}
interface HasOtherSportCourtParams {
  hasOtherSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasOvenApplianceParams {
  hasOvenAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasPackageServiceParams {
  hasPackageService?: boolean;
  listingAlias: ListingAlias;
}
interface HasParkingLotParkingParams {
  hasParkingLotParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasParkViewParams {
  hasParkView?: boolean;
  listingAlias: ListingAlias;
}
interface HasPartyRoomCommunityRoomParams {
  hasPartyRoomCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasPatioBalconyParams {
  hasPatioBalcony?: boolean;
  listingAlias: ListingAlias;
}
interface HasPatioOutDoorCommonAreaParams {
  hasPatioOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasPetParkParams {
  hasPetPark?: boolean;
  listingAlias: ListingAlias;
}
interface HasPetWashingStationCommunityRoomParams {
  hasPetWashingStationCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasPicnicAreaOutDoorCommonAreaParams {
  hasPicnicAreaOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasPlaygroundOutDoorCommonAreaParams {
  hasPlaygroundOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasPropaneButaneHeatingSourceParams {
  hasPropaneButaneHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasRacquetballSportCourtParams {
  hasRacquetballSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasRangeApplianceParams {
  hasRangeAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasRefrigeratorApplianceParams {
  hasRefrigeratorAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasRooftopDeckOutDoorCommonAreaParams {
  hasRooftopDeckOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasSatelliteTvParams {
  hasSatelliteTv?: boolean;
  listingAlias: ListingAlias;
}
interface HasSaunaParams {
  hasSauna?: boolean;
  listingAlias: ListingAlias;
}
interface HasSewageUtilityIncludedParams {
  hasSewageUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasShuffleboardSportCourtParams {
  hasShuffleboardSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasSixMonthsLeaseLengthsParams {
  hasSixMonthsLeaseLengths?: boolean;
  listingAlias: ListingAlias;
}
interface HasSlateFloorCoveringParams {
  hasSlateFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasSoftwoodFloorCoveringParams {
  hasSoftwoodFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasSolarHeatingSourceParams {
  hasSolarHeatingSource?: boolean;
  listingAlias: ListingAlias;
}
interface HasSpanishSpeakingStaffParams {
  hasSpanishSpeakingStaff?: boolean;
  listingAlias: ListingAlias;
}
interface HasSportsFieldSportCourtParams {
  hasSportsFieldSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasStorageSpaceParams {
  hasStorageSpace?: boolean;
  listingAlias: ListingAlias;
}
interface HasSwimmingPoolParams {
  hasSwimmingPool?: boolean;
  listingAlias: ListingAlias;
}
interface HasTennisSportCourtParams {
  hasTennisSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasTerritorialViewParams {
  hasTerritorialView?: boolean;
  listingAlias: ListingAlias;
}
interface HasTheaterCommunityRoomParams {
  hasTheaterCommunityRoom?: boolean;
  listingAlias: ListingAlias;
}
interface HasTileFloorCoveringParams {
  hasTileFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasTrailOutDoorCommonAreaParams {
  hasTrailOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasTrashCompactorApplianceParams {
  hasTrashCompactorAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasTwentyFourHourMaintenanceParams {
  hasTwentyFourHourMaintenance?: boolean;
  listingAlias: ListingAlias;
}
interface HasUndergroundGarageParkingParams {
  hasUndergroundGarageParking?: boolean;
  listingAlias: ListingAlias;
}
interface HasValetTrashParams {
  hasValetTrash?: boolean;
  listingAlias: ListingAlias;
}
interface HasVinylFloorCoveringParams {
  hasVinylFloorCovering?: boolean;
  listingAlias: ListingAlias;
}
interface HasVolleyballSportCourtParams {
  hasVolleyballSportCourt?: boolean;
  listingAlias: ListingAlias;
}
interface HasWallAirConditioningParams {
  hasWallAirConditioning?: boolean;
  listingAlias: ListingAlias;
}
interface HasWasherDryerHookupsApplianceParams {
  hasWasherDryerHookupsAppliance?: boolean;
  listingAlias: ListingAlias;
}
interface HasWaterFeatureOutDoorCommonAreaParams {
  hasWaterFeatureOutDoorCommonArea?: boolean;
  listingAlias: ListingAlias;
}
interface HasWaterUtilityIncludedParams {
  hasWaterUtilityIncluded?: boolean;
  listingAlias: ListingAlias;
}
interface HasWaterViewParams {
  hasWaterView?: boolean;
  listingAlias: ListingAlias;
}
interface HasWindowAirConditioningParams {
  hasWindowAirConditioning?: boolean;
  listingAlias: ListingAlias;
}
interface HasWoodedViewParams {
  hasWoodedView?: boolean;
  listingAlias: ListingAlias;
}
interface HidePhoneParams {
  hidePhone?: boolean;
  listingAlias: ListingAlias;
}
interface HideStreetAddressParams {
  hideStreetAddress?: boolean;
  listingAlias: ListingAlias;
}
interface IsApplicationsAcceptedParams {
  applicationFeeAmount?: number;
  inviteOnly?: boolean;
  isApplicationsAccepted?: boolean;
  propertyId: ListingAlias;
  requireUserName?: boolean;
}
interface IsBrokerExclusiveParams {
  isBrokerExclusive?: boolean;
  listingAlias: ListingAlias;
}
interface IsConnectedExperienceParams {
  listingAlias: ListingAlias;
}
interface IsFurnishedParams {
  isFurnished?: boolean;
  listingAlias: ListingAlias;
}
interface IsIncomeRestrictedParams {
  isIncomeRestricted?: boolean;
  listingAlias: ListingAlias;
}
interface IsListingEditableParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId?: string;
}
interface IsOver55Params {
  isOver55?: boolean;
  listingAlias: ListingAlias;
}
interface IsRentersInsuranceRequiredParams {
  isRentersInsuranceRequired?: boolean;
  propertyId: ListingAlias;
}
interface LaundryParams {
  laundry?: RentalManagerLaundryType;
  listingAlias: ListingAlias;
}
interface LeaseDurationParams {
  leaseDuration?: LeaseDuration;
  listingAlias: ListingAlias;
}
interface LeaseTermsParams {
  leaseTerms?: string;
  listingAlias: ListingAlias;
}
interface ModularListingProgressParams {
  listingAlias: ListingAlias;
  step: string;
}
interface NameParams {
  listingAlias: ListingAlias;
  name?: string;
}
interface ParkingDescriptionParams {
  listingAlias: ListingAlias;
  parkingDescription?: string;
}
interface PetPolicyDescriptionParams {
  listingAlias: ListingAlias;
  petPolicyDescription?: string;
}
interface PhoneParams {
  listingAlias: ListingAlias;
  phone?: string;
}
interface PropertyTypeParams {
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
}
interface SecurityDepositParams {
  listingAlias: ListingAlias;
  securityDeposit?: number;
}
interface SetAsPropertyOnlyParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId?: string;
}
interface SmokingAllowedParams {
  listingAlias: ListingAlias;
  smokingAllowed?: boolean;
}
interface UnitsInBuildingParams {
  listingAlias: ListingAlias;
  unitsInBuilding?: number;
}
interface VideoUrlParams {
  listingAlias: ListingAlias;
  videoUrl?: string;
}
interface WebSiteParams {
  listingAlias: ListingAlias;
  webSite?: string;
}

export interface RentalManagerUserPropertyEditWebApiHandler_additionalEmail_Args {
  getParams: AdditionalEmailParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_additionalEmail_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_additionalEmail_Args
>;

/**
 * Update secondary email of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_additionalEmail = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_additionalEmail_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_additionalEmail_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_additionalEmail(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_agentLicenseType_Args {
  getParams: AgentLicenseTypeParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_agentLicenseType_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_agentLicenseType_Args
>;

/**
 * Update agent license type
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_agentLicenseType = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_agentLicenseType_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_agentLicenseType_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_agentLicenseType(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_clearPropertyOnly_Args {
  getParams: ClearPropertyOnlyParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_clearPropertyOnly_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_clearPropertyOnly_Args
>;

/**
 * Clear the property-only flag for the listing (or multiplex units) so it shows again
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_clearPropertyOnly = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_clearPropertyOnly_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_clearPropertyOnly_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_clearPropertyOnly(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_contactHours_Args {
  getParams: ContactHoursParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_contactHours_Options = UseMutationOptions<
  UserPropertyEditContactHoursResponseWebDto,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_contactHours_Args
>;

/**
 * Update contact hours for a given day of a MF property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_contactHours = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_contactHours_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_contactHours_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_contactHours(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_contactName_Args {
  getParams: ContactNameParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_contactName_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_contactName_Args
>;

/**
 * Update contact name of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_contactName = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_contactName_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_contactName_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_contactName(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee_Args {
  getParams: DisplayTotalMonthlyPriceWithFeeParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee_Args
>;

/**
 * Update display total monthly price with fee of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_displayTotalMonthlyPriceWithFee(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_email_Args {
  getParams: EmailParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_email_Options = UseMutationOptions<
  UserPropertyEditEmailResponseWebDto,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_email_Args
>;

/**
 * Update contact email of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_email = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_email_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_email_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_email(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_forRentBy_Args {
  getParams: ForRentByParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_forRentBy_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_forRentBy_Args
>;

/**
 * Update forRentBy of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_forRentBy = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_forRentBy_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_forRentBy_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_forRentBy(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded_Args {
  getParams: HasAirConditioningUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded_Args
>;

/**
 * Update cooling included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasAirConditioningUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving_Args {
  getParams: HasAssistedLivingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving_Args
>;

/**
 * Update assisted living of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasAssistedLiving(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking_Args {
  getParams: HasAttachedGarageParkingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking_Args
>;

/**
 * Update attached garage parking of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasAttachedGarageParking(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasBarbecue_Args {
  getParams: HasBarbecueParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasBarbecue_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasBarbecue_Args
>;

/**
 * Update barbecue of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasBarbecue = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasBarbecue_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasBarbecue_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasBarbecue(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt_Args {
  getParams: HasBasketballSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt_Args
>;

/**
 * Update basketball court of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasBasketballSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage_Args {
  getParams: HasBicycleStorageParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage_Args
>;

/**
 * Update bicycle storage of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasBicycleStorage(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt_Args {
  getParams: HasBocceSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt_Args
>;

/**
 * Update bocce court of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasBocceSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless_Args {
  getParams: HasBuildingWideWirelessParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless_Args
>;

/**
 * Update building wide wireless availability of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasBuildingWideWireless(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom_Args {
  getParams: HasBusinessCenterCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom_Args
>;

/**
 * Update business center of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasBusinessCenterCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasCableTv_Args {
  getParams: HasCableTvParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasCableTv_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasCableTv_Args
>;

/**
 * Update cable tv availability of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasCableTv = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasCableTv_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasCableTv_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasCableTv(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded_Args {
  getParams: HasCableTvUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded_Args
>;

/**
 * Update cable tv included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasCableTvUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering_Args {
  getParams: HasCarpetFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering_Args
>;

/**
 * Update carpet flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasCarpetFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan_Args {
  getParams: HasCeilingFanParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan_Args
>;

/**
 * Update ceiling fan of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasCeilingFan = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasCeilingFan(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning_Args {
  getParams: HasCentralAirConditioningParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning_Args
>;

/**
 * Update central air conditioning of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasCentralAirConditioning(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasCityView_Args {
  getParams: HasCityViewParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasCityView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasCityView_Args
>;

/**
 * Update city view of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasCityView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasCityView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasCityView_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasCityView(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom_Args {
  getParams: HasClubHouseCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom_Args
>;

/**
 * Update club house of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasClubHouseCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasConcreteFloorCovering_Args {
  getParams: HasConcreteFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasConcreteFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasConcreteFloorCovering_Args
>;

/**
 * Update concrete flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasConcreteFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasConcreteFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasConcreteFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasConcreteFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom_Args {
  getParams: HasConferenceRoomCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom_Args
>;

/**
 * Update conference room of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasConferenceRoomCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity_Args {
  getParams: HasControlledAccessSecurityParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity_Args
>;

/**
 * Update controlled access security of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasControlledAccessSecurity(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance_Args {
  getParams: HasConvectionOvenApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance_Args
>;

/**
 * Update convection oven appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasConvectionOvenAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking_Args {
  getParams: HasCoveredParkingParkingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking_Args
>;

/**
 * Update covered parking of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasCoveredParkingParking(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea_Args {
  getParams: HasDeckOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea_Args
>;

/**
 * Update deck of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasDeckOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking_Args {
  getParams: HasDetachedGarageParkingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking_Args
>;

/**
 * Update detached garage parking of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasDetachedGarageParking(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess_Args {
  getParams: HasDisabledAccessParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess_Args
>;

/**
 * Update disabled access of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasDisabledAccess(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance_Args {
  getParams: HasDishwasherApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance_Args
>;

/**
 * Update dishwasher appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasDishwasherAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity_Args {
  getParams: HasDoormanSecurityParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity_Args
>;

/**
 * Update doorman security of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasDoormanSecurity(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance_Args {
  getParams: HasDoubleOvenApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance_Args
>;

/**
 * Update double oven appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasDoubleOvenAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff_Args {
  getParams: HasDryCleaningDropOffParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff_Args
>;

/**
 * Update dry cleaning drop off of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasDryCleaningDropOff(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource_Args {
  getParams: HasElectricHeatingSourceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource_Args
>;

/**
 * Update electric heating source of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasElectricHeatingSource(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded_Args {
  getParams: HasElectricityUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded_Args
>;

/**
 * Update electricity included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasElectricityUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasElevator_Args {
  getParams: HasElevatorParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasElevator_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasElevator_Args
>;

/**
 * Update elevator of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasElevator = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasElevator_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasElevator_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasElevator(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasFireplace_Args {
  getParams: HasFireplaceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasFireplace_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasFireplace_Args
>;

/**
 * Update fireplace of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasFireplace = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasFireplace_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasFireplace_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasFireplace(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom_Args {
  getParams: HasFitnessCenterCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom_Args
>;

/**
 * Update fitness center of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasFitnessCenterCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths_Args {
  getParams: HasFlexibleLeaseLengthsParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths_Args
>;

/**
 * Update flexible lease length of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasFlexibleLeaseLengths(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance_Args {
  getParams: HasFreezerApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance_Args
>;

/**
 * Update freezer appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasFreezerAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom_Args {
  getParams: HasGameRoomCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom_Args
>;

/**
 * Update game room of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGameRoomCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance_Args {
  getParams: HasGarbageDisposalApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance_Args
>;

/**
 * Update garbage disposal appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGarbageDisposalAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded_Args {
  getParams: HasGarbageUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded_Args
>;

/**
 * Update garbage included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGarbageUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea_Args {
  getParams: HasGardenOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea_Args
>;

/**
 * Update garden of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGardenOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource_Args {
  getParams: HasGasHeatingSourceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource_Args
>;

/**
 * Update gas heating source of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGasHeatingSource(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded_Args {
  getParams: HasGasUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded_Args
>;

/**
 * Update gas included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGasUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity_Args {
  getParams: HasGatedEntrySecurityParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity_Args
>;

/**
 * Update gated entry security of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGatedEntrySecurity(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea_Args {
  getParams: HasGazeboOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea_Args
>;

/**
 * Update gazebo of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGazeboOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView_Args {
  getParams: HasGolfCourseViewParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView_Args
>;

/**
 * Update golf course view of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGolfCourseView(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite_Args {
  getParams: HasGuestSuiteParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite_Args
>;

/**
 * Update guest suite of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasGuestSuite = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasGuestSuite(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering_Args {
  getParams: HasHardwoodFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering_Args
>;

/**
 * Update hardwood flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasHardwoodFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded_Args {
  getParams: HasHeatingUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded_Args
>;

/**
 * Update heat included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasHeatingUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource_Args {
  getParams: HasHeatPumpHeatingSourceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource_Args
>;

/**
 * Update heat pump heating source of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasHeatPumpHeatingSource(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet_Args {
  getParams: HasHighSpeedInternetParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet_Args
>;

/**
 * Update high speed internet availability of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasHighSpeedInternet(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasHotTub_Args {
  getParams: HasHotTubParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasHotTub_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasHotTub_Args
>;

/**
 * Update hot tub of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasHotTub = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasHotTub_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasHotTub_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasHotTub(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded_Args {
  getParams: HasHotWaterUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded_Args
>;

/**
 * Update hot water included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasHotWaterUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity_Args {
  getParams: HasIntercomSecurityParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity_Args
>;

/**
 * Update intercom security of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasIntercomSecurity(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded_Args {
  getParams: HasInternetUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded_Args
>;

/**
 * Update internet included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasInternetUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering_Args {
  getParams: HasLaminateFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering_Args
>;

/**
 * Update laminate flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasLaminateFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea_Args {
  getParams: HasLawnOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea_Args
>;

/**
 * Update lawn of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasLawnOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths_Args {
  getParams: HasLessThanOneYearLeaseLengthsParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths_Args
>;

/**
 * Update less than one year lease length of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasLessThanOneYearLeaseLengths(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom_Args {
  getParams: HasLibraryCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom_Args
>;

/**
 * Update library of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasLibraryCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering_Args {
  getParams: HasLinoleumFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering_Args
>;

/**
 * Update linoleum flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasLinoleumFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom_Args {
  getParams: HasLoungeCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom_Args
>;

/**
 * Update lounge of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasLoungeCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance_Args {
  getParams: HasMicrowaveOvenApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance_Args
>;

/**
 * Update microwave appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasMicrowaveOvenAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths_Args {
  getParams: HasMonthlyLeaseLengthsParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths_Args
>;

/**
 * Update monthly lease length of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasMonthlyLeaseLengths(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths_Args {
  getParams: HasMoreThanOneYearLeaseLengthsParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths_Args
>;

/**
 * Update more than one year lease length of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasMoreThanOneYearLeaseLengths(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasMountainView_Args {
  getParams: HasMountainViewParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasMountainView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasMountainView_Args
>;

/**
 * Update mountain view of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasMountainView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasMountainView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasMountainView_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasMountainView(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking_Args {
  getParams: HasMultiLevelGarageParkingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking_Args
>;

/**
 * Update multi-level garage parking of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasMultiLevelGarageParking(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt_Args {
  getParams: HasMultiPurposeSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt_Args
>;

/**
 * Update multi-purpose sports court of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasMultiPurposeSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity_Args {
  getParams: HasNightPatrolSecurityParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity_Args
>;

/**
 * Update night patrol security of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasNightPatrolSecurity(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths_Args {
  getParams: HasNoneLeaseLengthsParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths_Args
>;

/**
 * Update 'None' lease length of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasNoneLeaseLengths(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasNoneParking_Args {
  getParams: HasNoneParkingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasNoneParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasNoneParking_Args
>;

/**
 * Update None parking amenity of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasNoneParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasNoneParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasNoneParking_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasNoneParking(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource_Args {
  getParams: HasOilHeatingSourceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource_Args
>;

/**
 * Update oil heating source of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasOilHeatingSource(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths_Args {
  getParams: HasOneYearLeaseLengthsParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths_Args
>;

/**
 * Update one year lease length of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasOneYearLeaseLengths(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal_Args {
  getParams: HasOnlineMaintenancePortalParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal_Args
>;

/**
 * Update online maintenance portal of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasOnlineMaintenancePortal(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment_Args {
  getParams: HasOnlineRentPaymentParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment_Args
>;

/**
 * Update online rent payment of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasOnlineRentPayment(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement_Args {
  getParams: HasOnsiteManagementParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement_Args
>;

/**
 * Update onsite management of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasOnsiteManagement(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt_Args {
  getParams: HasOtherSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt_Args
>;

/**
 * Update other sports court of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasOtherSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance_Args {
  getParams: HasOvenApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance_Args
>;

/**
 * Update oven appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasOvenAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPackageService_Args {
  getParams: HasPackageServiceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPackageService_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPackageService_Args
>;

/**
 * Update package service of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPackageService = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPackageService_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPackageService_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPackageService(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking_Args {
  getParams: HasParkingLotParkingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking_Args
>;

/**
 * Update parking lot of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasParkingLotParking(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasParkView_Args {
  getParams: HasParkViewParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasParkView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasParkView_Args
>;

/**
 * Update park view of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasParkView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasParkView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasParkView_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasParkView(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom_Args {
  getParams: HasPartyRoomCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom_Args
>;

/**
 * Update party room of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPartyRoomCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony_Args {
  getParams: HasPatioBalconyParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony_Args
>;

/**
 * Update patio balcony of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPatioBalcony(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea_Args {
  getParams: HasPatioOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea_Args
>;

/**
 * Update patio of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPatioOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPetPark_Args {
  getParams: HasPetParkParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPetPark_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPetPark_Args
>;

/**
 * Update pet park of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPetPark = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPetPark_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPetPark_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPetPark(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom_Args {
  getParams: HasPetWashingStationCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom_Args
>;

/**
 * Update pet washing station of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPetWashingStationCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea_Args {
  getParams: HasPicnicAreaOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea_Args
>;

/**
 * Update picnic area of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPicnicAreaOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea_Args {
  getParams: HasPlaygroundOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea_Args
>;

/**
 * Update playground of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPlaygroundOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource_Args {
  getParams: HasPropaneButaneHeatingSourceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource_Args
>;

/**
 * Update propane/butane heating source of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasPropaneButaneHeatingSource(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt_Args {
  getParams: HasRacquetballSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt_Args
>;

/**
 * Update racquetball court of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasRacquetballSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance_Args {
  getParams: HasRangeApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance_Args
>;

/**
 * Update range appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasRangeAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance_Args {
  getParams: HasRefrigeratorApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance_Args
>;

/**
 * Update refrigerator appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasRefrigeratorAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea_Args {
  getParams: HasRooftopDeckOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea_Args
>;

/**
 * Update rooftop deck of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasRooftopDeckOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv_Args {
  getParams: HasSatelliteTvParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv_Args
>;

/**
 * Update satellite tv availability of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSatelliteTv(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSauna_Args {
  getParams: HasSaunaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSauna_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSauna_Args
>;

/**
 * Update sauna of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSauna = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSauna_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSauna_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSauna(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded_Args {
  getParams: HasSewageUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded_Args
>;

/**
 * Update sewage included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSewageUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt_Args {
  getParams: HasShuffleboardSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt_Args
>;

/**
 * Update shuffleboard court of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasShuffleboardSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths_Args {
  getParams: HasSixMonthsLeaseLengthsParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths_Args
>;

/**
 * Update six month lease length of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSixMonthsLeaseLengths(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering_Args {
  getParams: HasSlateFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering_Args
>;

/**
 * Update slate flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSlateFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering_Args {
  getParams: HasSoftwoodFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering_Args
>;

/**
 * Update softwood flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSoftwoodFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource_Args {
  getParams: HasSolarHeatingSourceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource_Args
>;

/**
 * Update solar heating source of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSolarHeatingSource(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff_Args {
  getParams: HasSpanishSpeakingStaffParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff_Args
>;

/**
 * Update Spanish speaking staff of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSpanishSpeakingStaff(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt_Args {
  getParams: HasSportsFieldSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt_Args
>;

/**
 * Update sports field of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSportsFieldSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace_Args {
  getParams: HasStorageSpaceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace_Args
>;

/**
 * Update storage space of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasStorageSpace = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasStorageSpace(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool_Args {
  getParams: HasSwimmingPoolParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool_Args
>;

/**
 * Update swimming pool of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasSwimmingPool(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt_Args {
  getParams: HasTennisSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt_Args
>;

/**
 * Update tennis court of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasTennisSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView_Args {
  getParams: HasTerritorialViewParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView_Args
>;

/**
 * Update territorial view of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasTerritorialView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasTerritorialView(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom_Args {
  getParams: HasTheaterCommunityRoomParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom_Args
>;

/**
 * Update theater of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasTheaterCommunityRoom(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering_Args {
  getParams: HasTileFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering_Args
>;

/**
 * Update tile flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasTileFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea_Args {
  getParams: HasTrailOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea_Args
>;

/**
 * Update trail of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasTrailOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance_Args {
  getParams: HasTrashCompactorApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance_Args
>;

/**
 * Update trash compactor appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasTrashCompactorAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance_Args {
  getParams: HasTwentyFourHourMaintenanceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance_Args
>;

/**
 * Update 24 hour maintenance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasTwentyFourHourMaintenance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking_Args {
  getParams: HasUndergroundGarageParkingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking_Args
>;

/**
 * Update underground garage parking of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasUndergroundGarageParking(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasValetTrash_Args {
  getParams: HasValetTrashParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasValetTrash_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasValetTrash_Args
>;

/**
 * Update valet trash of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasValetTrash = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasValetTrash_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasValetTrash_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasValetTrash(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering_Args {
  getParams: HasVinylFloorCoveringParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering_Args
>;

/**
 * Update vinyl flooring of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasVinylFloorCovering(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt_Args {
  getParams: HasVolleyballSportCourtParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt_Args
>;

/**
 * Update volleyball court of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasVolleyballSportCourt(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning_Args {
  getParams: HasWallAirConditioningParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning_Args
>;

/**
 * Update wall air conditioning of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasWallAirConditioning(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance_Args {
  getParams: HasWasherDryerHookupsApplianceParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance_Args
>;

/**
 * Update washer/dryer hookups appliance of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasWasherDryerHookupsAppliance(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea_Args {
  getParams: HasWaterFeatureOutDoorCommonAreaParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea_Args
>;

/**
 * Update water feature of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasWaterFeatureOutDoorCommonArea(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded_Args {
  getParams: HasWaterUtilityIncludedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded_Args
>;

/**
 * Update water included of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasWaterUtilityIncluded(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasWaterView_Args {
  getParams: HasWaterViewParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasWaterView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasWaterView_Args
>;

/**
 * Update water view of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasWaterView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasWaterView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasWaterView_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasWaterView(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning_Args {
  getParams: HasWindowAirConditioningParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning_Args
>;

/**
 * Update window air conditioning of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasWindowAirConditioning(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hasWoodedView_Args {
  getParams: HasWoodedViewParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hasWoodedView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hasWoodedView_Args
>;

/**
 * Update wooded view of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hasWoodedView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hasWoodedView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hasWoodedView_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hasWoodedView(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hidePhone_Args {
  getParams: HidePhoneParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hidePhone_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hidePhone_Args
>;

/**
 * Update hidePhone of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hidePhone = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hidePhone_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hidePhone_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hidePhone(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress_Args {
  getParams: HideStreetAddressParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress_Args
>;

/**
 * Update hideStreetAddress of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_hideStreetAddress = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_hideStreetAddress(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted_Args {
  getParams: IsApplicationsAcceptedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted_Args
>;

/**
 * Update applications accepted of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_isApplicationsAccepted(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive_Args {
  getParams: IsBrokerExclusiveParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive_Args
>;

/**
 * Update is broker exclusive
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_isBrokerExclusive(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Options = UseQueryOptions<
  UserPropertyIsConnectedExperienceResponseWebDto,
  unknown,
  UserPropertyIsConnectedExperienceResponseWebDto,
  readonly [string, IsConnectedExperienceParams]
>;

const RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_GetKey = (
  getParams: IsConnectedExperienceParams,
) => [RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Path, getParams] as const;

export const RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_queryOptions = (
  getParams: IsConnectedExperienceParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get isConnectedExperience for a listing
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isConnectedExperience = (
  getParams: IsConnectedExperienceParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyEditWebApiHandler_isConnectedExperience.getKey =
  RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_GetKey;

export interface RentalManagerUserPropertyEditWebApiHandler_isFurnished_Args {
  getParams: IsFurnishedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_isFurnished_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_isFurnished_Args
>;

/**
 * Update furnished of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isFurnished = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_isFurnished_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_isFurnished_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_isFurnished(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted_Args {
  getParams: IsIncomeRestrictedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted_Args
>;

/**
 * Update income restricted of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_isIncomeRestricted(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string, IsListingEditableParams]
>;

const RentalManagerUserPropertyEditWebApiHandler_isListingEditable_GetKey = (getParams: IsListingEditableParams) =>
  [RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Path, getParams] as const;

export const RentalManagerUserPropertyEditWebApiHandler_isListingEditable_queryOptions = (
  getParams: IsListingEditableParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyEditWebApiHandler_isListingEditable_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyEditWebApiHandler_isListingEditable(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Check whether the listing (or multiplex building units) can be edited; no side effects
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isListingEditable = (
  getParams: IsListingEditableParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyEditWebApiHandler_isListingEditable_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyEditWebApiHandler_isListingEditable.getKey =
  RentalManagerUserPropertyEditWebApiHandler_isListingEditable_GetKey;

export interface RentalManagerUserPropertyEditWebApiHandler_isOver55_Args {
  getParams: IsOver55Params;
}

export type RentalManagerUserPropertyEditWebApiHandler_isOver55_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_isOver55_Args
>;

/**
 * Update over 55 of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isOver55 = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_isOver55_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_isOver55_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_isOver55(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired_Args {
  getParams: IsRentersInsuranceRequiredParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired_Args
>;

/**
 * Update renters insurance requirement
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_isRentersInsuranceRequired(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_laundry_Args {
  getParams: LaundryParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_laundry_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_laundry_Args
>;

/**
 * Update laundry of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_laundry = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_laundry_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_laundry_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_laundry(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_leaseDuration_Args {
  getParams: LeaseDurationParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_leaseDuration_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_leaseDuration_Args
>;

/**
 * Update lease duration of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_leaseDuration = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_leaseDuration_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_leaseDuration_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_leaseDuration(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_leaseTerms_Args {
  getParams: LeaseTermsParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_leaseTerms_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_leaseTerms_Args
>;

/**
 * Update lease terms of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_leaseTerms = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_leaseTerms_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_leaseTerms_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_leaseTerms(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_modularListingProgress_Args {
  getParams: ModularListingProgressParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_modularListingProgress_Options = UseMutationOptions<
  RentalManagerModularListingProgressWebDto,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_modularListingProgress_Args
>;

/**
 * Save modular listing progress. Pass step='review' to persist that the user reached review.
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_modularListingProgress = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_modularListingProgress_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_modularListingProgress_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_modularListingProgress(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_name_Args {
  getParams: NameParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_name_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_name_Args
>;

/**
 * Update name of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_name = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_name_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_name_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_name(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_parkingDescription_Args {
  getParams: ParkingDescriptionParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_parkingDescription_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_parkingDescription_Args
>;

/**
 * Update parking description of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_parkingDescription = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_parkingDescription_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_parkingDescription_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_parkingDescription(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription_Args {
  getParams: PetPolicyDescriptionParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription_Args
>;

/**
 * Update pet policy description of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_petPolicyDescription = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_petPolicyDescription(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_pets_Args {
  postData: UserPropertyEditPetsWebApiRequestDto;
}

export type RentalManagerUserPropertyEditWebApiHandler_pets_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_pets_Args
>;

/**
 * Update pet policy of a property
 */
export const useRentalManagerUserPropertyEditWebApiHandler_pets = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_pets_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_pets_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_pets(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_phone_Args {
  getParams: PhoneParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_phone_Options = UseMutationOptions<
  UserPropertyEditPhoneResponseWebDto,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_phone_Args
>;

/**
 * Update contact phone of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_phone = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_phone_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_phone_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_phone(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_propertyType_Args {
  getParams: PropertyTypeParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_propertyType_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_propertyType_Args
>;

/**
 * Update propertyType of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_propertyType = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_propertyType_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_propertyType_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_propertyType(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_securityDeposit_Args {
  getParams: SecurityDepositParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_securityDeposit_Options = UseMutationOptions<
  UserPropertyEditSecurityDepositResponseWebDto,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_securityDeposit_Args
>;

/**
 * Update security deposit for a single family listing
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_securityDeposit = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_securityDeposit_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_securityDeposit_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_securityDeposit(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_setAsPropertyOnly_Args {
  getParams: SetAsPropertyOnlyParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_setAsPropertyOnly_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_setAsPropertyOnly_Args
>;

/**
 * Mark the listing (or multiplex units) as property-only so it is hidden from listings
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_setAsPropertyOnly = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_setAsPropertyOnly_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_setAsPropertyOnly_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_setAsPropertyOnly(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_smokingAllowed_Args {
  getParams: SmokingAllowedParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_smokingAllowed_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_smokingAllowed_Args
>;

/**
 * Update smoking allowed of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_smokingAllowed = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_smokingAllowed_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_smokingAllowed_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_smokingAllowed(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding_Args {
  getParams: UnitsInBuildingParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding_Args
>;

/**
 * Update units in building of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_unitsInBuilding = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_unitsInBuilding(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_videoUrl_Args {
  getParams: VideoUrlParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_videoUrl_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_videoUrl_Args
>;

/**
 * Update video URL of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_videoUrl = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_videoUrl_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_videoUrl_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_videoUrl(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyEditWebApiHandler_webSite_Args {
  getParams: WebSiteParams;
}

export type RentalManagerUserPropertyEditWebApiHandler_webSite_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_webSite_Args
>;

/**
 * Update web site of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyEditWebApiHandler_webSite = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_webSite_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_webSite_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_webSite(args.getParams, httpClient),
  });
};
